import React, { useState } from "react";
import CustomError from "../Errors/CustomError";
import Asterisks from "../Asterisks/Asterisks";
import "./GmailInput.css";
const GmailInput = ({
  label,
  name,
  value = "",
  onChange,
  parentClassName = "",
  inputClassName = "",
  labelClassName = "",
  placeholder = "Enter email",
  parentStyle = {},
  inputStyle = {},
  labelStyle = {},
  maxLength,
  minLength,
  readOnly = false,
  disabled = false,
  required = false,
  spellcheck = false,
  size,
  pattern,
  autocomplete = "off",
  customError,
  asterisk,
}) => {
  return (
    <div
      className={
        parentClassName && parentClassName.trim() !== ""
          ? parentClassName
          : "default-email-parent-class"
      }
      style={parentStyle}>
      <label
        className={
          labelClassName && labelClassName.trim() !== ""
            ? labelClassName
            : "default-email-label-class"
        }
        style={labelStyle}>
        {label}  <Asterisks asterisk={asterisk} />
      </label>
      <div className="email-input-wrapper">
        <input
          name={name}
          type="email"
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          className={`${
            inputClassName && inputClassName.trim() !== ""
              ? inputClassName
              : "default-email-input-class"
          } ${customError ? "email-input-error" : ""}`}
          style={inputStyle}
          maxLength={maxLength}
          minLength={minLength}
          readOnly={readOnly}
          disabled={disabled}
          required={required}
          spellcheck={spellcheck}
          size={size}
          pattern={pattern}
          autocomplete={autocomplete}
        />
        {customError && (
          <i className="fas fa-exclamation-circle email-error-icon"></i>
        )}
      </div>
      {customError && <CustomError error={customError} />}
    </div>
  );
};

export default GmailInput;
